import { ViewConstructor, View } from "../view";
import { BaseApp } from "../app";
import ViewChain from "./view-chain";

/**
 * Represents a router route.
 */
export class Route
{
    private app: BaseApp;
    public pattern: RegExp;
    public viewType: ViewConstructor | ViewConstructor[];
    public initial: any;

    /** Whether or not the route is a chain (multiple views). */
    public get isChain() { return Array.isArray(this.viewType); }

    /**
     * Creates a new Route.
     * @param app App
     * @param pattern Pattern used to trigger the route. 
     * @param viewType Target view.
     * @param initial Initial data for views.
     */
    constructor(app: BaseApp, pattern: RoutePattern, viewType: ViewConstructor | ViewConstructor[], initial?: any)
    {
        this.app = app;
        if (!(pattern instanceof RegExp))
        {
            pattern = new RegExp(`^${pattern}$`);
        }
         
        this.pattern = pattern;
        this.viewType = viewType;
        this.initial = initial;
    }

    /**
     * Checks if the route matches a path.
     * @param path The path to check.
     */
    public match(path: string)
    {
        let result = this.pattern.test(path);
        return result;
    }

    /**
     * Executes the route.
     */
    public run(): PromiseLike<void>
    {
        if (Array.isArray(this.viewType))
        {
            let viewChain = new ViewChain(this.app, this);
            return viewChain.run();
        }
        else
        {
            return this.app.view(this.viewType, this.initial).then(() =>
            {
                
            });
        }
    }
}

/** Route pattern type. */
export type RoutePattern = string | RegExp;